import {Badge, Button, Card, Col, Form, Modal, Row, Table} from 'react-bootstrap'
import {defineMessages, useIntl} from 'react-intl'
import {IResOnePolicyApi, IResOneQuote, NodePolicy} from '../../../types/policiesApi'
import moment from 'moment'
import {InputCurrency} from '../../../components/InputCurrency'
import {useNavigate} from 'react-router-dom'
import {parseId} from '../../../helpers'
import {getMetalLevelValue, getDocumentVariant, getPaymentVariant} from '../../../helpers/consts'

import {GET_ONE_QUOTE} from '../../../gql/queries/newQuotesQuery'
import {useLazyQuery} from '@apollo/client'
import {useQuery} from '@apollo/client'
import {SignatureFormsEntriesTimeline} from '../../signatureFormsEntries/components/SignatureFormsEntriesTimeline'
import {GET_ALL_SIGNATURE_FORMS_ENTRIES_API} from '../../../gql/queries/signatureFormsEntriesApiQueries'
import {IResSignatureFormsEntriesAPI} from '../../../types/signatureFormsEntriesApi'
import {useEffect, useState} from 'react'
import {GET_ONE_POLICY_API} from '../../../gql/queries/policiesApiQueries'
import {GET_ALL_POLICIES_STATUSES} from '../../../gql/queries/policiesQueries'
import {GET_ZIP_INFO} from '../../../gql/queries/leadsQuery'
import {RenderFilePreview} from '../../onePolicy/components/documents/RenderFilePreview'
import {prependBackendUrl} from '../../../gql/client'
import {copyToClipboard} from '../../../../../utils/clipboardUtils'
import {getTitleByStatus} from '../../shared/utils'

import {BadgeStatePolicy} from '../../onePolicy/components/BadgeStatePolicy'
import {PhoneProviderActions} from '../../../components/telephony/PhoneProviderActions'

const M = defineMessages({
  loading: {id: 'common.loading', defaultMessage: 'Loading...'},
  errorLoading: {id: 'policies.list.preview.errorLoading', defaultMessage: 'Error loading policy'},
  titlePolicy: {id: 'policies.list.preview.titlePolicy', defaultMessage: 'Policy preview'},
  titleQuote: {id: 'policies.list.preview.titleQuote', defaultMessage: 'Quote preview'},
  // Sections
  sectionStatus: {id: 'policies.list.preview.section.status', defaultMessage: 'Policy status'},
  sectionInfo: {id: 'policies.list.preview.section.info', defaultMessage: 'Policy information'},
  sectionAddress: {id: 'policies.list.preview.section.address', defaultMessage: 'Address information'},
  physicalAddress: {id: 'policies.list.preview.section.physicalAddress', defaultMessage: 'Physical address'},
  mailingAddress: {id: 'policies.list.preview.section.mailingAddress', defaultMessage: 'Mailing address'},
  sectionMembers: {id: 'policies.list.preview.section.members', defaultMessage: 'Members'},
  sectionSignatureForms: {id: 'policies.list.preview.section.signatureForms', defaultMessage: 'Signature Forms'},
  emptySignatureForms: {id: 'policies.list.preview.empty.signatureForms', defaultMessage: 'There are no consent requests'},
  sectionClientDocuments: {id: 'policies.list.preview.section.clientDocuments', defaultMessage: 'Client Documents'},
  // Status summary
  statusPolicy: {id: 'policies.list.preview.status.policy', defaultMessage: 'Policy'},
  statusDocuments: {id: 'policies.list.preview.status.documents', defaultMessage: 'Documents'},
  statusPayment: {id: 'policies.list.preview.status.payment', defaultMessage: 'Payment'},
  // Field labels
  fieldPolicyName: {id: 'policies.list.preview.field.policyName', defaultMessage: 'Policy Name'},
  fieldPolicyType: {id: 'policies.list.preview.field.policyType', defaultMessage: 'Policy type'},
  fieldCarrier: {id: 'policies.list.preview.field.carrier', defaultMessage: 'Carrier'},
  fieldMemberId: {id: 'policies.list.preview.field.memberId', defaultMessage: 'Member ID'},
  fieldPlanId: {id: 'policies.list.preview.field.planId', defaultMessage: 'Plan Id'},
  fieldPlan: {id: 'policies.list.preview.field.plan', defaultMessage: 'Plan'},
  fieldEffectiveDate: {id: 'policies.list.preview.field.effectiveDate', defaultMessage: 'Effective date'},
  fieldMetalLevel: {id: 'policies.list.preview.field.metalLevel', defaultMessage: 'Metal Level'},
  fieldPremium: {id: 'policies.list.preview.field.premium', defaultMessage: 'Premium'},
  fieldPolicyTotalCost: {id: 'policies.list.preview.field.policyTotalCost', defaultMessage: 'Policy Total Cost'},
  fieldNominalValue: {id: 'policies.list.preview.field.nominalValue', defaultMessage: 'Nominal Value'},
  fieldAddress: {id: 'policies.list.preview.field.address', defaultMessage: 'Address'},
  fieldAddress1: {id: 'policies.list.preview.field.address1', defaultMessage: 'Address 1'},
  fieldAddress2: {id: 'policies.list.preview.field.address2', defaultMessage: 'Address 2'},
  fieldCity: {id: 'policies.list.preview.field.city', defaultMessage: 'City'},
  fieldState: {id: 'policies.list.preview.field.state', defaultMessage: 'State'},
  fieldZipCode: {id: 'policies.list.preview.field.zipCode', defaultMessage: 'Zip Code'},
  fieldCounty: {id: 'policies.list.preview.field.county', defaultMessage: 'County'},
  // Members table headers
  tableApplicant: {id: 'policies.list.preview.table.applicant', defaultMessage: 'Applicant'},
  tableRole: {id: 'policies.list.preview.table.role', defaultMessage: 'Role'},
  tableFirstName: {id: 'common.field.firstName', defaultMessage: 'First Name'},
  tableLastName: {id: 'common.field.lastName', defaultMessage: 'Last Name'},
  tableDateOfBirth: {id: 'common.field.dateOfBirth', defaultMessage: 'Date of Birth'},
  tableImmigration: {id: 'policies.list.preview.table.immigration', defaultMessage: 'Immigration'},
  tableSsn: {id: 'policies.list.preview.table.ssn', defaultMessage: 'SSN'},
  tableEmail: {id: 'common.field.email', defaultMessage: 'Email'},
  tablePhone: {id: 'common.field.phone', defaultMessage: 'Phone'},
  tableIncomes: {id: 'policies.list.preview.table.incomes', defaultMessage: 'Income(s)'},
  // Documents table headers
  tableFileName: {id: 'policies.list.preview.table.fileName', defaultMessage: 'File name'},
  tableUploadedBy: {id: 'policies.list.preview.table.uploadedBy', defaultMessage: 'Uploaded by'},
  tableBelongsTo: {id: 'policies.list.preview.table.belongsTo', defaultMessage: 'Belongs to'},
  tableExpiration: {id: 'policies.list.preview.table.expiration', defaultMessage: 'Expiration'},
  tableTag: {id: 'policies.list.preview.table.tag', defaultMessage: 'Tag'},
  tableActions: {id: 'common.field.actions', defaultMessage: 'Actions'},
  // Values / empties / misc
  valueNr: {id: 'policies.list.preview.value.nr', defaultMessage: 'N/R'},
  emptyMembers: {id: 'policies.list.preview.empty.members', defaultMessage: 'There are no members'},
  emptyDocuments: {
    id: 'policies.list.preview.empty.documents',
    defaultMessage: 'There are no documents uploaded for this policy.',
  },
  labelUser: {id: 'policies.list.preview.label.user', defaultMessage: 'User'},
  // Actions
  viewTitle: {id: 'policies.list.preview.action.view', defaultMessage: 'View'},
  viewPolicy: {id: 'policies.list.preview.action.viewPolicy', defaultMessage: 'View policy'},
  viewQuote: {id: 'policies.list.preview.action.viewQuote', defaultMessage: 'View quote'},
  close: {id: 'common.action.close', defaultMessage: 'Close'},
  // Copy-to-clipboard title, parametrized by field noun
  copyTitle: {id: 'policies.list.preview.copyTitle', defaultMessage: 'Copy {field}'},
  copyMailingAddress: {id: 'policies.list.preview.copyField.mailingAddress', defaultMessage: 'Mailing Address'},
  copyMailingAddress2: {id: 'policies.list.preview.copyField.mailingAddress2', defaultMessage: 'Mailing Address 2'},
  copyMailingCity: {id: 'policies.list.preview.copyField.mailingCity', defaultMessage: 'Mailing City'},
  copyMailingState: {id: 'policies.list.preview.copyField.mailingState', defaultMessage: 'Mailing State'},
  copyMailingZipCode: {id: 'policies.list.preview.copyField.mailingZipCode', defaultMessage: 'Mailing Zip Code'},
  copyMailingCounty: {id: 'policies.list.preview.copyField.mailingCounty', defaultMessage: 'Mailing County'},
  copyImmigrationStatus: {id: 'policies.list.preview.copyField.immigrationStatus', defaultMessage: 'Immigration Status'},
  copyIncome: {id: 'policies.list.preview.copyField.income', defaultMessage: 'Income'},
})

export const ModalPreview: React.FC<{
  onClose: () => void
  isOpen: boolean
  id: string
  isQuote?: boolean
  statusColor?: string
}> = ({id, isOpen, onClose, isQuote, statusColor}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const naValue = intl.formatMessage({id: 'common.value.notAvailable', defaultMessage: 'N/A'})
  const colon = ':' // non-translatable label separator (hoisted to avoid raw JSX literal)
  // Compose "<name>.<ext>" outside JSX so the literal dot isn't a raw JSX string.
  const fileDisplayName = (name: string, attachments: string) =>
    `${name}.${attachments.split('?')[0].split('.')?.pop()?.toLowerCase() || ''}`
  // Copy-icon title: "Copy {field}" with a translated field noun.
  const copyTitle = (field: {id: string; defaultMessage: string}) =>
    intl.formatMessage(M.copyTitle, {field: intl.formatMessage(field)})

  const [gqlGetPolicy, {data: dataPolicy, loading: loadingPolicy, error: errorPolicy}] =
    useLazyQuery<IResOnePolicyApi>(GET_ONE_POLICY_API, {fetchPolicy: 'no-cache'})

  const [gqlGetQuote, {data: dataQuote, loading: loadingQuote, error: errorQuote}] =
    useLazyQuery<IResOneQuote>(GET_ONE_QUOTE, {fetchPolicy: 'no-cache'})

  const {data: dataPoliciesStatuses} = useQuery(GET_ALL_POLICIES_STATUSES)

  const [updateZips, setUpdateZips] = useState(0)
  const [info, setData] = useState<NodePolicy>()
  const [physicalCountyName, setPhysicalCountyName] = useState<string>('')
  const [mailingCountyName, setMailingCountyName] = useState<string>('')

  const [gqlGetZipInfo] = useLazyQuery(GET_ZIP_INFO, {
    fetchPolicy: 'no-cache',
  })

  const getHolder = (p?: NodePolicy) => p?.memberPolicySet?.edges?.find(({node}) => node.rol === 'HOLDER')?.node

  useEffect(() => {
    if (!dataPolicy?.policiesById) return
    setUpdateZips(updateZips + 1)
    const {policiesById} = dataPolicy
    setData(policiesById)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataPolicy])

  useEffect(() => {
    if (!dataQuote?.quotesById) return
    setUpdateZips(updateZips + 1)
    const {quotesById} = dataQuote
    setData(quotesById)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataQuote])

  // Fetch county names and cities when policy info changes
  useEffect(() => {
    if (!info) return

    const fetchCountyNamesAndCities = async () => {
      // Physical address county name and city
      if (info.zipCode) {
        try {
          const {data} = await gqlGetZipInfo({
            variables: {zipCode: info.zipCode},
          })

          if (data?.zipcodeByZip) {
            const {countyFipsAll, countyNamesAll, city} = data.zipcodeByZip

            // Update county name
            if (info.countyFips) {
              const fipsArray = countyFipsAll ? countyFipsAll.split(',').map((f: string) => f.trim()) : []
              const namesArray = countyNamesAll ? countyNamesAll.split(',').map((n: string) => n.trim()) : []
              const index = fipsArray.findIndex((fips: string) => fips === info.countyFips)

              if (index !== -1 && namesArray[index]) {
                setPhysicalCountyName(namesArray[index])
              } else {
                setPhysicalCountyName(info.countyFips)
              }
            } else {
              setPhysicalCountyName('N/A')
            }

            // Update city if empty
            if ((!info.city || info.city.trim() === '') && city) {
              setData((prev) => prev ? {...prev, city} : prev)
            }
          }
        } catch (error) {
          console.error('Error fetching physical address info:', error)
          setPhysicalCountyName(info.countyFips || 'N/A')
        }
      } else {
        setPhysicalCountyName(info.countyFips || 'N/A')
      }

      // Mailing address county name and city
      if (info.mailingZipCode) {
        try {
          const {data} = await gqlGetZipInfo({
            variables: {zipCode: info.mailingZipCode},
          })

          if (data?.zipcodeByZip) {
            const {countyFipsAll, countyNamesAll, city} = data.zipcodeByZip

            // Update county name
            if (info.mailingCountyFips) {
              const fipsArray = countyFipsAll ? countyFipsAll.split(',').map((f: string) => f.trim()) : []
              const namesArray = countyNamesAll ? countyNamesAll.split(',').map((n: string) => n.trim()) : []
              const index = fipsArray.findIndex((fips: string) => fips === info.mailingCountyFips)

              if (index !== -1 && namesArray[index]) {
                setMailingCountyName(namesArray[index])
              } else {
                setMailingCountyName(info.mailingCountyFips)
              }
            } else {
              setMailingCountyName('N/A')
            }

            // Update mailing city if empty
            if ((!info.mailingCity || info.mailingCity.trim() === '') && city) {
              setData((prev) => prev ? {...prev, mailingCity: city} : prev)
            }
          }
        } catch (error) {
          console.error('Error fetching mailing address info:', error)
          setMailingCountyName(info.mailingCountyFips || 'N/A')
        }
      } else {
        setMailingCountyName(info.mailingCountyFips || 'N/A')
      }
    }

    fetchCountyNamesAndCities()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info])

  useEffect(() => {
    if (Number(parseId(id))) {
      if (!isQuote) {
        gqlGetPolicy({
          variables: {
            id: parseId(id),
          },
        })
      }
      if (isQuote) {
        gqlGetQuote({
          variables: {
            id: parseId(id),
          },
        })
      }
    }
  }, [gqlGetPolicy, gqlGetQuote, id, isQuote])

  // Tanto quotes como policies usan el parámetro 'policy' en la query GraphQL
  const entriesVars = {policy: parseId(id)}
  const {data: dataEntries, loading: loadingEntries, refetch: refetchEntries} =
    useQuery<IResSignatureFormsEntriesAPI>(
    GET_ALL_SIGNATURE_FORMS_ENTRIES_API,
    {
      variables: entriesVars as any,
      fetchPolicy: 'network-only',
      skip: !isOpen || !id,
    }
  )

  if (loadingPolicy || loadingQuote)
    return <div className='text-center'>{intl.formatMessage(M.loading)}</div>

  if (errorPolicy || errorQuote) {
    console.error('Error fetching policy:', errorPolicy || errorQuote)
    return <div className='text-center'>{intl.formatMessage(M.errorLoading)}</div>
  }

  return (
    <Modal
      backdrop='static'
      keyboard={false}
      show={isOpen}
      onHide={onClose}
      dialogClassName='modal-wide-sm'
    >
      {info && (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{intl.formatMessage(isQuote ? M.titleQuote : M.titlePolicy)}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{backgroundColor: '#f2f3f8'}} className='modal-body-policy-preview'>
            <Card className='policy-status-summary mb-3'>
              <Card.Title>
                <div className='kt-heading kt-heading--md custom-border-brand'>
                  {intl.formatMessage(M.sectionStatus)}
                </div>
              </Card.Title>
              <Card.Body>
                <Row className='g-2 align-items-center'>
                  <Col md={4} sm={12}>
                    <div className='d-flex align-items-center gap-2'>
                      <span className='fw-bold'>{intl.formatMessage(M.statusPolicy)}</span>
                      <span className='fs-6'>
                        <BadgeStatePolicy
                          status={getTitleByStatus(
                            dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                            info.status
                          )}
                          color={statusColor}
                        />
                      </span>
                    </div>
                  </Col>
                  <Col md={4} sm={12}>
                    <div className='d-flex align-items-center gap-2'>
                      <span className='fw-bold'>{intl.formatMessage(M.statusDocuments)}</span>
                      <Badge className="fs-6" bg={getDocumentVariant(info.stateDocs)}>
                        {info.stateDocs || naValue}
                      </Badge>
                    </div>
                  </Col>
                  <Col md={4} sm={12}>
                    <div className='d-flex align-items-center gap-2'>
                      <span className='fw-bold'>{intl.formatMessage(M.statusPayment)}</span>
                      <Badge className="fs-6" bg={getPaymentVariant(info.paymentStatus)}>
                        {info.paymentStatus || naValue}
                      </Badge>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className='policy-information'>
              <Card.Title>
                <div className='kt-heading kt-heading--md custom-border-brand'>
                  {intl.formatMessage(M.sectionInfo)}
                </div>
              </Card.Title>
              <Card.Body>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldPolicyName)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={info.policyName ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldPolicyType)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={info.typePolicy?.typePolicy ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldCarrier)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={info.carrier?.name ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldMemberId)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={info.memberId ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldPlanId)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={info.CMSPlanId ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldPlan)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={info.planName ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldEffectiveDate)}</Form.Label>
                      <Form.Control
                        type='date'
                        className='form-control-border-less'
                        defaultValue={
                          new Date(info.effectiveDate).toISOString().split('T')[0] ?? ''
                        }
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldMetalLevel)}</Form.Label>
                      <Form.Control
                        className='form-control-border-less'
                        defaultValue={getMetalLevelValue('' + info.metalLevel) ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldPremium)}</Form.Label>
                      <InputCurrency
                        className='form-control-border-less'
                        readOnly
                        defaultValue={info.premium ?? ''}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldPolicyTotalCost)}</Form.Label>
                      <InputCurrency
                        className='form-control-border-less'
                        readOnly
                        defaultValue={info.policyTotalCost ?? ''}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>{intl.formatMessage(M.fieldNominalValue)}</Form.Label>
                      <InputCurrency
                        className='form-control-border-less'
                        defaultValue={info.nominalValue ?? ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className='policy-address-information'>
              <Card.Title>
                <div className='kt-heading kt-heading--md custom-border-brand'>
                  {intl.formatMessage(M.sectionAddress)}
                </div>
              </Card.Title>
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <div className='policy-address-card'>
                      <div className='kt-heading kt-heading--md custom-border-brand'>
                        {intl.formatMessage(M.physicalAddress)}
                      </div>
                      <div className='details'>
                        <Row className='g-2 align-items-end'>
                          <Col md={info.address2 && info.address2.trim() !== '' ? 4 : 6} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>
                                {info.address2 && info.address2.trim() !== ''
                                  ? intl.formatMessage(M.fieldAddress1)
                                  : intl.formatMessage(M.fieldAddress)}
                              </Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.address1, 'Address')}
                                  title={copyTitle(M.fieldAddress)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  className='form-control-border-less'
                                  value={info.address1 ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          {info.address2 && info.address2.trim() !== '' && (
                            <Col md={4} sm={12}>
                              <Form.Group className='mb-2'>
                                <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldAddress2)}</Form.Label>
                                <div className='d-flex align-items-center gap-2'>
                                  <i
                                    className='bi bi-files'
                                    onClick={() => copyToClipboard(info.address2, 'Address 2')}
                                    title={copyTitle(M.fieldAddress2)}
                                    style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                  ></i>
                                  <Form.Control
                                    className='form-control-border-less'
                                    value={info.address2}
                                    readOnly
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                          )}
                          <Col md={info.address2 && info.address2.trim() !== '' ? 4 : 6} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldCity)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.city, 'City')}
                                  title={copyTitle(M.fieldCity)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  className='form-control-border-less'
                                  value={info.city ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className='g-2 align-items-end'>
                          <Col md={4} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldState)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.stateEU?.name, 'State')}
                                  title={copyTitle(M.fieldState)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  className='form-control-border-less'
                                  value={info.stateEU?.name ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldZipCode)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.zipCode, 'Zip Code')}
                                  title={copyTitle(M.fieldZipCode)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  type='text'
                                  className='form-control-border-less'
                                  value={info.zipCode ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldCounty)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(physicalCountyName || info.countyFips, 'County')}
                                  title={copyTitle(M.fieldCounty)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  type='text'
                                  className='form-control-border-less'
                                  value={physicalCountyName || info.countyFips || ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='policy-address-card'>
                      <div className='kt-heading kt-heading--md custom-border-brand'>
                        {intl.formatMessage(M.mailingAddress)}
                      </div>
                      <div className='details'>
                        <Row className='g-2 align-items-end'>
                          <Col md={info.mailingAddress2 && info.mailingAddress2.trim() !== '' ? 4 : 6} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>
                                {info.mailingAddress2 && info.mailingAddress2.trim() !== ''
                                  ? intl.formatMessage(M.fieldAddress1)
                                  : intl.formatMessage(M.fieldAddress)}
                              </Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.mailingAddress1, 'Mailing Address')}
                                  title={copyTitle(M.copyMailingAddress)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  className='form-control-border-less'
                                  value={info.mailingAddress1 ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          {info.mailingAddress2 && info.mailingAddress2.trim() !== '' && (
                            <Col md={4} sm={12}>
                              <Form.Group className='mb-2'>
                                <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldAddress2)}</Form.Label>
                                <div className='d-flex align-items-center gap-2'>
                                  <i
                                    className='bi bi-files'
                                    onClick={() => copyToClipboard(info.mailingAddress2, 'Mailing Address 2')}
                                    title={copyTitle(M.copyMailingAddress2)}
                                    style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                  ></i>
                                  <Form.Control
                                    className='form-control-border-less'
                                    value={info.mailingAddress2}
                                    readOnly
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                          )}
                          <Col md={info.mailingAddress2 && info.mailingAddress2.trim() !== '' ? 4 : 6} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldCity)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.mailingCity, 'Mailing City')}
                                  title={copyTitle(M.copyMailingCity)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  className='form-control-border-less'
                                  value={info.mailingCity ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className='g-2 align-items-end'>
                          <Col md={4} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldState)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.mailingStateeu?.name, 'Mailing State')}
                                  title={copyTitle(M.copyMailingState)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  className='form-control-border-less'
                                  value={info.mailingStateeu?.name ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldZipCode)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(info.mailingZipCode, 'Mailing Zip Code')}
                                  title={copyTitle(M.copyMailingZipCode)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  type='text'
                                  className='form-control-border-less'
                                  value={info.mailingZipCode ?? ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4} sm={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label className='fw-bold mb-1'>{intl.formatMessage(M.fieldCounty)}</Form.Label>
                              <div className='d-flex align-items-center gap-2'>
                                <i
                                  className='bi bi-files'
                                  onClick={() => copyToClipboard(mailingCountyName || info.mailingCountyFips, 'Mailing County')}
                                  title={copyTitle(M.copyMailingCounty)}
                                  style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                                ></i>
                                <Form.Control
                                  type='text'
                                  className='form-control-border-less'
                                  value={mailingCountyName || info.mailingCountyFips || ''}
                                  readOnly
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className='policy-members-information'>
              <Card.Title>
                <div className='kt-heading kt-heading--md custom-border-brand'>{intl.formatMessage(M.sectionMembers)}</div>
              </Card.Title>
              <Card.Body>
                {/* <Row className='my-4'>
              <Col md={6}>
                <Form.Label>Total applicants:</Form.Label>
                <p>{info.applicants}</p>
              </Col>
              <Col md={4}>
                <Form.Label>Total Members:</Form.Label>
                <p>{info.members}</p>
              </Col> 
              <Col md={6}>
                <Form.Label>Total dependents:</Form.Label>
                <p>{info.dependents}</p>
              </Col>
            </Row> */}
                <Table>
                  <thead>
                    <tr style={{backgroundColor: '#ebedf2'}}>
                      <th className='ps-2'>{intl.formatMessage(M.tableApplicant)}</th>
                      <th>{intl.formatMessage(M.tableRole)}</th>
                      <th>{intl.formatMessage(M.tableFirstName)}</th>
                      <th>{intl.formatMessage(M.tableLastName)}</th>
                      <th>{intl.formatMessage(M.tableDateOfBirth)}</th>
                      <th>{intl.formatMessage(M.tableImmigration)}</th>
                      <th>{intl.formatMessage(M.tableSsn)}</th>
                      <th>{intl.formatMessage(M.tableEmail)}</th>
                      <th>{intl.formatMessage(M.tablePhone)}</th>
                      <th>{intl.formatMessage(M.tableIncomes)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {info.memberPolicySet.edges.map(({node}) => (
                      <tr key={node.id}>
                        <td className='ps-2'>
                          <Badge bg={node.applicant ? 'success' : 'danger'}>
                            {node.applicant
                              ? intl.formatMessage({id: 'common.boolean.yes', defaultMessage: 'Yes'})
                              : intl.formatMessage({id: 'common.boolean.no', defaultMessage: 'No'})}
                          </Badge>
                        </td>
                        <td>{node.rol}</td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard(node.firstName, 'First Name')}
                              title={copyTitle(M.tableFirstName)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <span>{node.firstName || ''}</span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard([node.lastName, node.secondLastName].filter(Boolean).join(' '), 'Last Name')}
                              title={copyTitle(M.tableLastName)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <span>{[node.lastName, node.secondLastName].filter(Boolean).join(' ')}</span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard(node.dateBirth ? moment(node.dateBirth).format('MM/DD/YYYY') : '', 'Date of Birth')}
                              title={copyTitle(M.tableDateOfBirth)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <span>{node.dateBirth ? moment(node.dateBirth).format('MM/DD/YYYY') : naValue}</span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard(node.immigrationStatus, 'Immigration Status')}
                              title={copyTitle(M.copyImmigrationStatus)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <span>{node.immigrationStatus || intl.formatMessage(M.valueNr)}</span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard(node.ssn, 'SSN')}
                              title={copyTitle(M.tableSsn)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <span>{node.ssn || naValue}</span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard(node.emailAddress, 'Email')}
                              title={copyTitle(M.tableEmail)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <span>{node.emailAddress || naValue}</span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => copyToClipboard(node.phone, 'Phone')}
                              title={copyTitle(M.tablePhone)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <PhoneProviderActions phone={node.phone} emptyText={naValue} />
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center gap-1'>
                            <i
                              className='bi bi-files'
                              onClick={() => {
                                const income1 = parseFloat(node.annualIncome1 || '0') || 0
                                const income2 = parseFloat(node.annualIncome2 || '0') || 0
                                const income3 = parseFloat(node.annualIncome3 || '0') || 0
                                const totalIncome = income1 + income2 + income3
                                copyToClipboard(String(totalIncome), 'Income')
                              }}
                              title={copyTitle(M.copyIncome)}
                              style={{fontSize: '0.85rem', cursor: 'pointer', color: '#009ef7'}}
                            ></i>
                            <InputCurrency
                              readOnly
                              className="form-control-border-less"
                              value={
                                (parseFloat(node.annualIncome1 || '0') || 0) +
                                (parseFloat(node.annualIncome2 || '0') || 0) +
                                (parseFloat(node.annualIncome3 || '0') || 0)
                              }
                            />
                          </div>
                      </td>
                      </tr>
                    ))}
                    {info.memberPolicySet.edges.length === 0 && (
                      <tr>
                        <td colSpan={10}>
                          <div className='d-flex flex-center' style={{height: '120px'}}>
                            <p className='text-center'>{intl.formatMessage(M.emptyMembers)}</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='policy-signature-entries mt-4'>
              <Card.Title>
                <div className='kt-heading kt-heading--md custom-border-brand'>{intl.formatMessage(M.sectionSignatureForms)}</div>
              </Card.Title>
              <Card.Body>
                <SignatureFormsEntriesTimeline
                  loading={loadingEntries}
                  dataEntriesByLead={dataEntries?.allSignatureFormsEntries}
                  refetch={refetchEntries}
                  emptyMessage={intl.formatMessage(M.emptySignatureForms)}
                  hasEmail={Boolean(getHolder(info)?.emailAddress && getHolder(info)?.emailAddress.trim() !== '')}
                  hasPhone={Boolean(getHolder(info)?.phone && getHolder(info)?.phone.trim() !== '')}
                  compact
                />
              </Card.Body>
            </Card>
            <Card className='policy-documents mt-4'>
              <Card.Title>
                <div className='kt-heading kt-heading--md custom-border-brand'>{intl.formatMessage(M.sectionClientDocuments)}</div>
              </Card.Title>
              <Card.Body>
                <div className='row'>
                  <div className='col-sm-12 px-2' style={{overflowX: 'auto'}}>
                    <Table className='table table-hover no-footer' style={{whiteSpace: 'nowrap'}}>
                      <thead>
                        <tr>
                          <th style={{width: 30}}>&nbsp;</th>
                          <th className='fw-bold'>{intl.formatMessage(M.tableFileName)}</th>
                          <th className='fw-bold'>{intl.formatMessage(M.tableUploadedBy)}</th>
                          <th className='fw-bold'>{intl.formatMessage(M.tableBelongsTo)}</th>
                          <th className='fw-bold'>{intl.formatMessage(M.tableExpiration)}</th>
                          <th className='fw-bold'>{intl.formatMessage(M.tableTag)}</th>
                          <th className='fw-bold text-right'>{intl.formatMessage(M.tableActions)}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(info.policyAttachmentsSet?.edges || []).map(({node}) => (
                          <tr key={node.id}>
                            <td>
                              <RenderFilePreview file={prependBackendUrl(node.attachments)} />
                            </td>
                            <td style={{textAlign: 'left', verticalAlign: 'middle'}}>
                              {fileDisplayName(node.name, node.attachments)}
                            </td>
                            <td>
                              <div>
                                <p className='m-0 p-0'>
                                  <span className='fw-bold'>{intl.formatMessage(M.labelUser)}{colon}</span>
                                  <span>
                                    {node.user.firstName} {node.user.lastName}
                                  </span>
                                </p>
                                <small className='m-0 p-0'>
                                  {moment(node.created).format('MMM DD, YYYY hh:mm A')}
                                </small>
                              </div>
                            </td>
                            <td>
                              {node.memberPolicy ? (
                                <span>
                                  {node.memberPolicy.firstName} {node.memberPolicy.lastName}
                                </span>
                              ) : (
                                <span></span>
                              )}
                            </td>
                            <td>
                              {node.expirationDate ? (
                                moment(node.expirationDate).format('DD MMM YYYY')
                              ) : (
                                <span></span>
                              )}
                            </td>
                            <td>
                              {node.documentTag ? (
                                <span>{node.documentTag.tagName}</span>
                              ) : (
                                <span></span>
                              )}
                            </td>
                            <td className='text-right'>
                              <button
                                onClick={() => window.open(prependBackendUrl(node.attachments), '_blank')}
                                className='btn-reset'
                                title={intl.formatMessage(M.viewTitle)}
                              >
                                <i className='bi bi-eye text-primary fs-2' />
                              </button>
                            </td>
                          </tr>
                        ))}
                        {(info.policyAttachmentsSet?.edges || []).length === 0 && (
                          <tr className='odd'>
                            <td colSpan={7} className='dataTables_empty'>
                              <div
                                className='d-flex align-items-center justify-content-center flex-column'
                                style={{padding: '3% 0', backgroundColor: '#f0f3ff'}}
                              >
                                <svg style={{width: 50, height: 50}} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' className='kt-svg-icon mb-3'>
                                  <g stroke='none' fill='none' fillRule='evenodd'>
                                    <rect x={0} y={0} width={24} height={24} />
                                    <path d='M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z' fill='#000000' opacity='0.3' />
                                    <path d='M8.63657261,16.4632487 C7.65328954,15.8436137 7,14.7480988 7,13.5 C7,11.5670034 8.56700338,10 10.5,10 C12.263236,10 13.7219407,11.3038529 13.9645556,13 L15,13 C16.1045695,13 17,13.8954305 17,15 C17,16.1045695 16.1045695,17 15,17 L10,17 C9.47310652,17 8.99380073,16.7962529 8.63657261,16.4632487 Z' fill='#000000' />
                                  </g>
                                </svg>
                                <h5 className='kt-font-dark'>{intl.formatMessage(M.emptyDocuments)}</h5>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' size='sm' onClick={onClose}>
              {intl.formatMessage(M.close)}
            </Button>
            <Button
              className='btn btn-primary'
              size='sm'
              onClick={() =>
                navigate(
                  isQuote ? `/one-quote/${parseId(info.id)}` : `/one-policy/${parseId(info.id)}`
                )
              }
            >
              {intl.formatMessage(isQuote ? M.viewQuote : M.viewPolicy)}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  )
}
